import React, { Suspense, useState, useEffect } from 'react';
import { iconMap as iconMapLazy } from './iconMapLazy';

// Simple loading placeholder - renders a box the same size as the icon
const IconPlaceholder = ({ size = 24 }) => (
  <div 
    style={{ 
      width: size, 
      height: size, 
      display: 'inline-block',
      backgroundColor: 'transparent'
    }} 
  />
);

export default function Icon({ name, size = 24, className = '', ...props }) {
  const [IconComponent, setIconComponent] = useState(null);
  useEffect(() => {
    try {
      const LazyComponent = iconMapLazy[name];
      if (LazyComponent) {
        setIconComponent(() => LazyComponent);
      } else {
        console.warn(`Icon "${name}" not found in iconMapLazy.`);
        setIconComponent(null);
      }
    } catch (error) {
      console.error(`Error loading icon "${name}":`, error);
      setIconComponent(null);
    }
  }, [name]);

  if (!IconComponent) {
    return <IconPlaceholder size={size} />;
  }

  const combinedClassName = `[&_path]:fill-current [&_g]:fill-current ${className}`.trim();

  return (
    <Suspense fallback={<IconPlaceholder size={size} />}>
      <IconComponent
        width={size}
        height={size}
        role="img"
        aria-label={name}
        className={combinedClassName}
        {...props}
      />
    </Suspense>
  );
}
